var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 97,
    viewBox: "0 0 75 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3994 3V3C44.8183 3 47.1381 3.96134 48.848 5.67235L69.7932 26.6315C71.2599 28.0992 72.0838 30.0892 72.0838 32.1641V32.1641M42.3994 3H12.595C7.2958 3 3 7.29582 3 12.595V83.5978C3 88.8969 7.29582 93.1927 12.595 93.1927H62.4888C67.788 93.1927 72.0838 88.8969 72.0838 83.5978V32.1641M42.3994 3V22.5691C42.3994 27.8683 46.6952 32.1641 51.9943 32.1641H72.0838",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 63.6667H23.3333C24.4826 63.6667 25.5848 63.2101 26.3975 62.3975C27.2101 61.5848 27.6667 60.4826 27.6667 59.3333C27.6667 58.1841 27.2101 57.0819 26.3975 56.2692C25.5848 55.4565 24.4826 55 23.3333 55H19V72.3333M49.3333 63.6667H55.8333M58 55H49.3333V72.3333M34.1667 55V72.3333H38.5C39.6493 72.3333 40.7515 71.8768 41.5641 71.0641C42.3768 70.2515 42.8333 69.1493 42.8333 68V59.3333C42.8333 58.1841 42.3768 57.0819 41.5641 56.2692C40.7515 55.4565 39.6493 55 38.5 55H34.1667Z",
    stroke: "#292D32",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.58cf3ec41ffbd5643b8fa34d43976e4b.svg";
export { ForwardRef as ReactComponent };